import { Constants } from "app/utility/constants";
import { ProductClass } from "app/utility/enums";

export class SaleProductsSearchParamsModel {
    searchText: string = '';
    productClass: ProductClass = ProductClass.General;
    saleId: string = Constants.EmptyGuid;
    vehicleId: string = Constants.EmptyGuid;
}
